/* eslint-disable camelcase */

import type { CreatedByUser } from '../common/CreatedByUser';

export const FEEDBACK_NAME_MAX_LENGTH = 50;

export const FEEDBACK_LABEL_MAX_LENGTH = 20;

export interface Feedback {
  id: number;
  name: string;
  background: string;
  enabled: boolean;
  description: null | string;
  created_epoch_time: number;
  response_count: number;
  created_by_user: CreatedByUser;
  emotion_style: 'default' | 'emoji' | 'star' | 'smiley';
}
